import React from 'react'

function PlayIcon(props) {
    return (
    <svg width="26" height="24" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.9453 11.8113L4.61198 16.6225L4.61198 7L12.9453 11.8113Z" fill="#71D89A"/>
    </svg>

)
}

export default PlayIcon
